// Özel boyut yönetimi kopyası (TODO-KPI-146) — kpi-breakdown-copy.ts 600 satır sınırı için ayrı
// dosya; `KPI_BREAKDOWN_COPY.dimensions` olarak açılır (tek kaynak).

/** TODO-KPI-146 (K-B4) — Katalog "Boyutları yönet" penceresi (özel boyut düzenle / sil). */
export const KPI_DIMENSIONS_COPY = {
  open: "Boyutları yönet",
  kicker: "Kırılım boyutları",
  title: "Sizin tanımladığınız boyutlar",
  intro:
    "Hazır boyutlar değiştirilemez. Burada kendi tanımladığınız boyutların adını, üyelerini ve uygun olduğu kategorileri düzenleyebilir, kullanılmayanları silebilirsiniz.",
  empty: "Henüz kendi tanımladığınız bir boyut yok.",
  members: (n: number) => `${n.toString()} üye`,
  noMembers: "Üye şablonu yok",
  edit: "Düzenle",
  remove: "Sil",
  save: "Kaydet",
  saving: "Kaydediliyor…",
  cancel: "Vazgeç",
  close: "Kapat",
  labelLabel: "Boyut adı",
  membersLabel: "Üye şablonu (her satıra bir üye)",
  categoriesLabel: "Uygun kategoriler",
  categoriesHint: "Hiçbiri seçili değilse boyut her kategoride 'Diğer boyutlar' altında görünür.",
  slugLine: (slug: string) => `Kod: ${slug}`,
  roots: {
    cevresel: "Çevresel",
    sosyal: "Sosyal",
    yonetisim: "Yönetişim",
    ekonomik: "Ekonomik",
  },
  removeConfirmTitle: (label: string) => `'${label}' boyutu silinsin mi?`,
  removeConfirmBody: "Boyut sözlükten kalkar; bu işlem geri alınamaz.",
  removeConfirm: "Sil",
  inUse: (groups: number) =>
    `Bu boyutu kullanan ${groups.toString()} kırılım grubu var; silmeden önce o grupları kaldırın.`,
  presetLocked: "Hazır boyut değiştirilemez ya da silinemez.",
  saved: "Boyut güncellendi",
  removed: "Boyut silindi",
  failed: "İşlem yapılamadı",
} as const;
